export default (function (value) {
  return value === null;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isNull.js
// module id = fPAS
// module chunks = 0